<template>
  <el-row>
    <el-row>
      <el-col :span="1">
        <span class="c-pointer" @click="onFoldMessage()" v-show="showFlag"><i class="far fa-angle-down mr-r4" /></span>
        <span class="c-pointer" @click="onFoldMessage()" v-show="!showFlag"><i class="far fa-angle-right mr-r4" /></span>
      </el-col>
      <el-col :span="23">
        <el-row v-show="!showFlag">
          <span>{{getStringFormatter(logMessage.originMessage)}}</span>
        </el-row>
        <el-row v-show="showFlag">
          <div class="mr-b10">{{getStringFormatter(logMessage.originMessage)}}</div>
          <div>
            <em>[상세 정보]</em>
          </div>
          <div v-for="(item, index) in fieldOptions" :key="index">{{`${item.fieldName} : ${(item.fieldId === 'timestamp') ? getDateFormatter(logMessage[item.fieldId]) : getStringFormatter(logMessage[item.fieldId])}`}}</div>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { getIntervalDatetimeParams, getDateToString } from '@/utils/date';

export default {
  name: 'WLogKeywordMessage',
  props: {
    logMessage: {
      type: Object,
    },
    fieldOptions: {
      type: Array,
    },
  },
  data() {
    return {
      showFlag: false,
    };
  },
  watch: {
    logMessage: {
      deep: true,
      handler() {
        this.showFlag = false;
      },
    },
  },
  methods: {
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },

    getStringFormatter(value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    onFoldMessage() {
      this.showFlag = !this.showFlag;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/LogKeywordMessage.vue